import useObservable from 'front-end-core/hooks/useObservable'
import { User, $emailPreferences } from 'services/SessionService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import { EmailPreferences, User as UserT } from 'types/User'
import AolPreferences from './AolPreferences'
import { RESPONSE_PENDING } from 'front-end-core/constants/responses'

const Preferences = () => {
  const preferences: EmailPreferences = useObservable($emailPreferences, RESPONSE_PENDING)
  const user: UserT = useObservable(User, RESPONSE_PENDING)

  return (
    <ResponseConsumer
      responses={[preferences, user]}
      content={() => <AolPreferences accessRoles={user.accessRoles} preferences={preferences} />}
    />
  )
}

export default Preferences
